export default __webpack_public_path__ + "static/media/Nutzungsbedingungen.0bf01ac3.md";